import { reactive } from 'vue'
import moment from 'moment-timezone'
import PermissionsService from './PermissionsService'

const darkMode = localStorage.getItem('preferences.darkMode') === '1'
let browserLocale = 'en'
if (navigator.language) {
  browserLocale = navigator.language.slice(0, 2) // in case it's something like "en-US"
}
const locale = localStorage.getItem('preferences.locale') ?? browserLocale ?? 'en'
const timezone =  localStorage.getItem('preferences.timezone') ?? moment.tz.guess() ?? 'America/New_York'
const showIds = PermissionsService.can('seeids') && localStorage.getItem('preferences.showIds') === '1'

class PreferencesService {

  preferences = reactive({
    darkMode: darkMode,
    locale: locale,
    timezone: timezone,
    showIds: showIds,
  })

  savePreference(name: string, value: string) {
    localStorage.setItem(`preferences.${name}`, value)
  }

}

export default new PreferencesService()
